// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4962) return "static/chunks/4962-c629f354a4429a10.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2634":"2c796e83","7409":"ee9ce975"}[chunkId] || chunkId) + "." + {"1323":"86d8be06665f4771","2410":"e68a0aabc7febd5f","2634":"e257bf8cc1d070e7","7409":"a77a524a13cf50cb"}[chunkId] + ".js";
};